import { getApiBaseUrl } from './config';

export interface NewsLikeStatus {
  liked: boolean;
  likeCount: number;
}

function likeAuthHeaders(): HeadersInit {
  return {
    'Content-Type': 'application/json',
    'X-Client': 'web',
  };
}

export async function toggleNewsLike(newsId: number): Promise<NewsLikeStatus> {
  const res = await fetch(`${getApiBaseUrl()}/api/news/${newsId}/like`, {
    method: 'POST',
    credentials: 'include',
    headers: likeAuthHeaders(),
  });

  if (!res.ok) {
    const data = (await res.json().catch(() => null)) as { message?: string } | null;
    throw new Error(data?.message || 'Beğeni işlemi başarısız');
  }

  return res.json();
}

export async function fetchNewsLikeStatus(newsId: number): Promise<NewsLikeStatus> {
  const res = await fetch(`${getApiBaseUrl()}/api/news/${newsId}/like`, {
    credentials: 'include',
    headers: likeAuthHeaders(),
  });

  if (!res.ok) {
    return { liked: false, likeCount: 0 };
  }

  return res.json();
}
